import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './globals.css';

// Set default color theme before React renders
const savedTheme = localStorage.getItem('color-theme');
const defaultTheme = savedTheme || 'orange';
document.documentElement.setAttribute('data-theme', defaultTheme);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
